export const JanusAPIEndpoint = {
    VideoRoom: "api/v1/stream/videoRoom",
    VideoRoomV2: "api/v1/stream/videoRoom-v2",
    VideoCall: "api/v1/stream/videoCall",
    PushCall: "api/v1/stream/videoCall/pushCall",
    PushCallV2: "api/v1/stream/videoCall/pushCallV2",
    Call: "api/v1/stream/videoCall/call",
    confRoom: "/api/v1/stream/conference/active",
    CreateConfRoom: "api/v1/stream/create",
    LiveRoom: `/api/v1/stream/live/active`,
    LiveFriend: '/api/v1/stream/live/friend'
};